<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic" :class="{titleTrue:$isTRUE}">TR-069 Configuration</h4>
            <el-form :model="form"
            :inline-message="true"
            :rules="rules"
            ref="forms"
            label-width="180px" 
            label-position="left"
            class="fhv-form abc" 
            :class="{formTrue:$isTRUE}"
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="TR069:">
                <el-radio v-model="form.tr069" label="0" >Disabled</el-radio>
                <el-radio v-model="form.tr069" label="1" >Enabled</el-radio>
            </el-form-item>
              <el-form-item label="ACS" >
              </el-form-item>
             <el-form-item label="URL:" prop="url">
                <el-input v-model="form.url"></el-input>
            </el-form-item>
            <el-form-item label="User Name:" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="Password:" prop="password">
                <el-input v-model="form.password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="Periodic Inform Enable:" >
                <el-radio v-model="form.inform" label="0" >Disabled</el-radio>
                <el-radio v-model="form.inform" label="1" >Enabled</el-radio>
            </el-form-item>
            <el-form-item label="Periodic Inform Interval:" prop="interval">
                <el-input v-model="form.interval" :disabled="form.inform==0"></el-input>
            </el-form-item>
            <el-form-item label="Connection Request" >
            </el-form-item>
            <el-form-item label="User Name:" prop="name1">
                <el-input v-model="form.name1"></el-input>
            </el-form-item>
             <el-form-item label="Password:" prop="password1">
                <el-input v-model="form.password1" type="password"></el-input>
            </el-form-item>
            <el-form-item label="Path:" prop="path">
                <el-input  v-model="form.path"></el-input>
            </el-form-item>
             <el-form-item label="Port:" prop="port">
                <el-input v-model="form.port"></el-input>
            </el-form-item>
            <el-form-item label="STUN Connection" >
            </el-form-item>
            <el-form-item label="STUN:" >
                <el-radio  label="0" v-model="form.stun">Disabled</el-radio>
                <el-radio  label="1" v-model="form.stun">Enabled</el-radio>
            </el-form-item>
             <el-form-item label="STUN Server URL:" prop="url1">
                <el-input v-model="form.url1"></el-input>
            </el-form-item>
            <el-form-item label="STUN Server Port:" prop="port1">
                <el-input v-model="form.port1"></el-input>
            </el-form-item>
            <el-form-item >
                <el-button type="primary" @click="save">Save</el-button>
            </el-form-item>
            <el-form-item label="CA Certificat:">
                 <input type="file" ref="file" :disabled="$G_DEVICE_CFG.isReadOnly">
            </el-form-item>
            <el-form-item >
                <el-button type="primary" @click="sendFile">Upload</el-button>
            </el-form-item>
        </el-form>

    </div>
    
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      data: {},
      form: {
        tr069: "1",
        url: "",
        name: "",
        password: "",
        inform: "1",
        interval: "",
        name1: "",
        password1: "",
        path: "",
        port: "",
        stun: "1",
        url1: "",
        port1: ""
      },
      rules: {
        url: [
          {required: true,message: "ACS URL cannot be empty！",trigger: "blur"
          }
        ],
        name: [
          { required: true, message: "Invalid User Name！", trigger: "blur" }
        ],
        password: [
          { required: true, message: "Invalid Password！", trigger: "blur" }
        ],
        interval: [
          {
            validator: (rule, value, callback) => {
              if (this.form.inform == "1") {
                if (value == "") {
                  callback(new Error("Please input periodic interval time！"));
                } else {
                  callback();
                }
              }else{
                callback();
              }
            },
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (this.form.inform == "1") {
                if (!validator.isInt(value)) {
                  callback(
                    new Error("Interval should be the decimal number (0-9)！")
                  );
                } else {
                  callback();
                }
              }else{
                 callback();
              }
            },
            trigger: "blur"
          }
        ],
        name1: [
          { required: true, message: "Invalid User Name！", trigger: "blur" }
        ],
        password1: [
          { required: true, message: "Invalid Password！", trigger: "blur" }
        ],
        path: [{ required: true, message: "Invalid Path！", trigger: "blur" }],
        port: [
           {
            validator: (rule, value, callback) => {
                if (!validator.isInt(value, { min: 1, max: 65535 })) {
                  callback(
                    new Error(
                      "Please input the port number for connection request！"
                    )
                  );
                } else {
                  callback();
                }
            },
            trigger: "blur"
          }
        ],
        url1: [
          {
            validator: (rule, value, callback) => {
              if (this.data.tr069_stun_on && this.form.stun == "1") {
                if (value == "") {
                  callback(new Error("STUN Server URL cannot be empty！"));
                } else {
                  callback();
                }
              }else{
                callback()
              }
            },
            trigger: "blur"
          }
        ],
        port1: [
          {
            validator: (rule, value, callback) => {
              if (this.data.tr069_stun_on && this.form.stun == "1") {
                if (!validator.isInt(value, { min: 1, max: 65535 })) {
                  callback(
                    new Error(
                      "Invalid port number of STUN Server. It should be 0-65535！"
                    )
                  );
                } else {
                  callback();
                }
              }else{
                callback(); 
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    getData() {
      this.loading = true;
      axios.post("/boafrm/getcwmp").then(res => {
        this.loading = false;
        let data = res.data;
        this.data = data;
        this.form.tr069 = data.DaylightSave;
        this.form.url = data.acs_url;
        this.form.name = data.acs_username;
        this.form.password = data.acs_password;
        this.form.inform = data.inform;
        this.form.interval = data.interval;
        this.form.name1 = data.conreq_name;
        this.form.password1 = data.conreq_pw;
        this.form.path = data.conreq_path;
        this.form.port = data.conreq_port;
        this.form.stun = data.stun;
        this.form.url1 = data.stun_url;
        this.form.port1 = data.stun_port;
      });
    },
    save() {
      let postData = {
        autoexec: this.form.tr069,
        url: this.form.url,
        username: this.form.name,
        password: this.form.password,
        enable: this.form.inform,
        interval: this.form.interval,
        conreqname: this.form.name1,
        conreqpw: this.form.password1,
        conreqpath: this.form.path,
        conreqport: this.form.port,
        stunStatus: this.form.stun,
        stunUrl: this.form.url1,
        stunPort: this.form.port1,
        save: "Save",
        "submit-url": "/tr069config.htm"
      };

      this.$refs["forms"].validate(valid => {
        if (valid) {
          this.loading = true;
          axios.post("/boafrm/setformTR069Config", postData).then(res => {
            this.loading = false;
            this.$message.success(res.data.msg);
            this.getData();
          });
        }
      });
    },
    sendFile() {
      let file = this.$refs.file.files[0];
      let param = new FormData(); //创建form对象
      param.append("binary", file); //通过append向form对象添加数据
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      }; //添加请求头
      if (!file) {
        this.$message.error("please select a file！");
        return;
      }
      this.loading = true;
      axios.post("/boafrm/setformTR069CACert", param, config).then(res => {
        this.loading = false;
        if (res.data) {
          this.$message.error(res.data.msg);
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style scoped>
.titleTrue {
    margin-left: calc(40% - 300px)
}
@media (max-width: 1065px){
    .titleTrue,.formTrue{
        padding: 0 2rem;
        margin-left:0;
    }
}   
</style>






